import { Injectable } from '@angular/core';


import { HttpClient } from '@angular/common/http';
import { GlobalConstants } from '../Constants/global.constants';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FacilityService {

    constructor(private _http: HttpClient) { }
    getAllfacility(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Facility/Filter';
        return this._http.post(url, request);
    }






    addfacility(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Facility/Create';
        return this._http.post(url, request);
    }




    getfacilityBySensorTargetId(sensorId: any, targetid: any): Observable<any> {
        var url = GlobalConstants.API_URL + `api/facility/getModelsBySensorAndTarget?sensorId=${sensorId}&targetid=${targetid}`;
        return this._http.get(url);
    }

    deletefacility(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + `Facility/Delete?id=` + request;
        return this._http.delete(url, request);
    }

    update(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Facility/Update?id=' + request.id;
        return this._http.put(url, request);
    }

    getFacilityDropdown(request: any): Observable<any> {
        var url = GlobalConstants.API_URL + 'Facility/GetAllForDropDown';
        return this._http.get(url);
    }

  


}